import { render, staticRenderFns } from "./RestaurantSelector.vue?vue&type=template&id=2951d1c2&scoped=true&lang=pug&"
import script from "./RestaurantSelector.vue?vue&type=script&lang=js&"
export * from "./RestaurantSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2951d1c2",
  null
  
)

export default component.exports